import { render } from "./Background.vue?vue&type=template&id=12fea5ae&scoped=true"
const script = {}

import "./Background.vue?vue&type=style&index=0&id=12fea5ae&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Raska\\Desktop\\raska\\projekat\\astra\\astra-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12fea5ae"]])

export default __exports__